import FormLoadHelper from './FormLoadHelper';
export default class CommonUtil
{
	static calcResourcePath(url)
	{
		var _url;
		if(url.substr(0, 5)=="@tmp/")
		{
			_url = window.parent.window.userInfos.serviceURL + "/tmp/" + url.substr(5);
		}
		else
		{
			_url = window.parent.window.userInfos.resourceURL + "/" + url;
		}
		
		return _url;
	}

	static delayFunc(delay,thisObj,f,...args)
	{
		let id = setTimeout(function(){clearTimeout(id);f.apply(thisObj,args);},delay)
	}

	static guid() 
	{
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
	      return v.toString(16);
	    });
	}

	static getUrlParam(token)
	{
		var reg = new RegExp("(^|&)" + token + "=([^&]*)(&|$)", "i");  
		var r = window.location.search.substr(1).match(reg);  
		if (r != null) 
			return unescape(r[2]);
		else  
			return null;  
	}

	static getUrlParam2(token,queryString)
	{
		if(!queryString)return null;
		var reg = new RegExp("(^|&)" + token + "=([^&]*)(&|$)", "i");  
		var r = queryString.match(reg);  
		if (r != null) 
			return unescape(r[2]);
		else  
			return null;  
	}

	static getLayerClassName(formName,groupAlias)
	{
		if(groupAlias)
			return formName+"_DataSource_"+groupAlias;
		else
			return formName;
	}
		
	static getClientLayerRowStyles(formModule,group,methodName,args)
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
		{
		  let layerLevels = _parentWindow.layerLevelConfig;
		  //let formModule = this.formDataSources.formModule;
		  for(let i = layerLevels.length-1;i>-1;i--)
		  {
				let layerName = layerLevels[i].name;
				let layerConfig = _parentWindow.layerConfigs[layerName];
				if(layerConfig)
				{
					let clsName = CommonUtil.getLayerClassName(formModule.formName,group?group.mainSource.alias:null);
					if(layerConfig.hasOwnProperty(clsName))
					{
						let classConfig = layerConfig[clsName];
						let _cls = classConfig.classDef;
						let result;
						let mathodInfo = {fetchOption:true,groups:"all(cr,sr,ar,fq,cq)",editors:"all",joinGroup:"yes"};
						if(typeof(_cls) == "function")
						{
							let instance = new _cls();
							let func = instance[methodName];
							if(!func || typeof(func) != "function")
								continue;
						
							//cmdResult = instance.activeRecord(commandArg);
							result = func.apply(instance,args);
						}
						else if(typeof(_cls == "Object"))
						{
							let instance = _cls;
							let func = instance[methodName];
							if(!func || typeof(func) != "function")
								continue;
						
							result = func.apply(instance,args);
						}
						if(result)
						{
							return result;
						}
						break;
					}
				}
		  }
	
		}
	}

	assignDisplayStyle(_style,_displayStyle)
	{
		if(_displayStyle.Color)_style.color = _displayStyle.Color;
		if(_displayStyle.cssStyle)Object.assign(_style,_displayStyle.cssStyle);
		return _style;
	}

	/**
   * 动态加载JS
   * @param {string} url 脚本地址
   * @param {function} callback  回调函数
   */
	static dynamicLoadJs(url, callback) 
	{
		var head = document.getElementsByTagName('head')[0];
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = url;
		if(typeof(callback)=='function'){
			script.onload = script.onreadystatechange = function () {
				if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete"){
					if(callback)callback();
					script.onload = script.onreadystatechange = null;
				}
			};
		}
		head.appendChild(script);
  	}
  
  /**
	 * 动态加载Css
	 * @param {string} url 脚本地址
	 * @param {function} callback  回调函数
  */
  static dynamicLoadCss(url, callback) 
  {
	  //<link rel="stylesheet" href="externals/styles/GongqiERP6.css"></link>
	  var head = document.getElementsByTagName('head')[0];
	  var _css_ = document.createElement('link');
	  _css_.rel = "stylesheet";
	  _css_.href = url;
	  if(typeof(callback)=='function'){
		  script.onload = script.onreadystatechange = function () {
			  if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete"){
				  if(callback)callback();
				  script.onload = script.onreadystatechange = null;
			  }
		  };
	  }
	  head.appendChild(_css_);
  }









  static drawCanvas(data,_idp,_id) 
  {
	console.log(data, '=====>data')
	var c = document.getElementById(_id);
	var ctx = c.getContext("2d");
	CommonUtil.resizeCanvas(_idp,_id);
	data.forEach(item => {
	  let spaceLength = 5
	  if (item.shape === 'rect') {
		// 节点部分
  
		CommonUtil.creatdiv(item,_idp,_id);
		ctx.strokeStyle = "#000"
		let leftTop = {
		  x: item.position.x,
		  y: item.position.y
		}
		let leftBottom = {
		  x: item.position.x,
		  y: item.position.y + item.size.height
		}
		// 绘制节点框
		ctx.fillStyle = "#fff";
		ctx.fillRect(item.position.x + spaceLength, item.position.y + spaceLength, item.size.width - spaceLength * 2, item.size.height - spaceLength * 2);
		// 绘制名称
		ctx.fillStyle = "#000"
		ctx.font = "12px Arial";
		ctx.textAlign = 'center';
		ctx.fillText(item.attrs.label.text, item.position.x + item.size.width / 2, leftBottom.y - 10);
		// 绘制图片
		var image = new Image();
		image.src = "./images/box.png";
		image.onload = function () {
		  let x = leftTop.x + (item.size.width / 2) - item.size.height / 4
		  let y = leftTop.y + (item.size.height / 2) - item.size.height / 3
		  ctx.drawImage(this, x, y, item.size.height / 2, item.size.height / 2);
		}
	  } else {
		// 连接线部分
		let pointS = {
		  x: 0,
		  y: 0
		}
		let pointE = {
		  x: 0,
		  y: 0
		}
		let targetWidth = 0
		let targetHeight = 0
		// 定位起始点，结束点位置
		data.find(i => {
		  if (i.id === item.source.cell) {
			pointS = {
			  x: i.position.x + (i.size.width / 2),
			  y: i.position.y + (i.size.height / 2)
			}
		  }
		  if (i.id === item.target.cell) {
			pointE = {
			  x: i.position.x + (i.size.width / 2),
			  y: i.position.y + (i.size.height / 2)
			}
			targetWidth = i.size.width
			targetHeight = i.size.height
		  }
		})
  
		// 绘制连接线
		ctx.strokeStyle = "#000"
		ctx.fillStyle = "#000"
		let direction = ''
		let turn1 = {
		  x: 0,
		  y: 0
		}
		let turn2 = {
		  x: 0,
		  y: 0
		}
		if (pointS.x !== pointE.x && pointS.y !== pointE.y) {
		  if (Math.abs(pointS.x - pointE.x) > Math.abs(pointS.y - pointE.y)) {
			// 转折点1
			turn1 = {
			  x: (pointE.x < pointS.x ? pointE.x : pointS.x) + Math.abs(pointS.x - pointE.x) / 2,
			  y: pointS.y
			}
			// 转折点2
			turn2 = {
			  x: (pointE.x < pointS.x ? pointE.x : pointS.x) + Math.abs(pointS.x - pointE.x) / 2,
			  y: pointE.y
			}
			// 折线连接
			ctx.moveTo(pointS.x, pointS.y)
			ctx.lineTo(turn1.x, turn1.y)
			ctx.lineTo(turn2.x, turn2.y )
			ctx.lineTo(pointE.x, pointE.y)
			ctx.stroke();
		  } else {
			// 转折点1
			turn1 = {
			  x: pointS.x,
			  y: (pointE.y < pointS.y ? pointE.y : pointS.y) + Math.abs(pointS.y - pointE.y) / 2
			}
			// 转折点2
			turn2 = {
			  x: pointE.x,
			  y: (pointE.y < pointS.y ? pointE.y : pointS.y) + Math.abs(pointS.y - pointE.y) / 2
			}
			// 折线连接
			ctx.moveTo(pointS.x, pointS.y)
			ctx.lineTo(turn1.x, turn1.y)
			ctx.lineTo(turn2.x, turn2.y)
			ctx.lineTo(pointE.x, pointE.y)
			ctx.stroke();
		  }
		  // 判断箭头方向
		  if (turn2.x > pointE.x) {
			direction = 'left'
		  } else if (turn2.x < pointE.x) {
			direction = 'right'
		  } else if (turn2.y > pointE.y) {
			direction = 'top'
		  } else if (turn2.y < pointE.y) {
			direction = 'bottom'
		  }
		} else {
		  // 直线连接
		  ctx.moveTo(pointS.x, pointS.y)
		  ctx.lineTo(pointE.x, pointE.y)
		  ctx.stroke();
		  // 判断箭头方向
		  if (pointS.x > pointE.x) {
			direction = 'left'
		  } else if (pointS.x < pointE.x) {
			direction = 'right'
		  } else if (pointS.y > pointE.y) {
			direction = 'top'
		  } else if (pointS.y < pointE.y) {
			direction = 'bottom'
		  }
		}
		// 绘制箭头
		let len = 3
		switch (direction) {
		  case 'right':
			ctx.beginPath()
			ctx.moveTo(pointE.x - targetWidth / 2 - len, pointE.y - len)
			ctx.lineTo(pointE.x - targetWidth / 2 + spaceLength, pointE.y)
			ctx.lineTo(pointE.x - targetWidth / 2 - len, pointE.y + len)
			ctx.lineTo(pointE.x - targetWidth / 2 - len, pointE.y - len)
			ctx.fill()
			ctx.stroke();
			ctx.closePath();
			break;
		  case 'left':
			ctx.beginPath()
			ctx.moveTo(pointE.x + targetWidth / 2 + len, pointE.y - len)
			ctx.lineTo(pointE.x + targetWidth / 2 - spaceLength, pointE.y)
			ctx.lineTo(pointE.x + targetWidth / 2 + len, pointE.y + len)
			ctx.fill()
			ctx.stroke();
			ctx.closePath();
			break;
		  case 'bottom':
			ctx.beginPath()
			ctx.moveTo(pointE.x - len, pointE.y - targetHeight / 2 - len)
			ctx.lineTo(pointE.x, pointE.y - targetHeight / 2 + spaceLength)
			ctx.lineTo(pointE.x + len, pointE.y - targetHeight / 2 - len)
			ctx.fill()
			ctx.stroke();
			ctx.closePath();
			break;
		  case 'top':
			ctx.beginPath()
			ctx.moveTo(pointE.x - len, pointE.y + targetHeight / 2 + len)
			ctx.lineTo(pointE.x, pointE.y + targetHeight / 2 - spaceLength)
			ctx.lineTo(pointE.x + len, pointE.y + targetHeight / 2 + len)
			ctx.fill()
			ctx.stroke();
			ctx.closePath();
			break;
		}
	  }
	})
  }
  
  static creatdiv(item,_idp,_id) {
	let div = document.createElement('div')
	div.id = item.attrs.label.id
	div.style.position = "absolute"
	div.style.width = item.size.width + 'px'
	div.style.height = item.size.height + 'px'
	div.style.left = item.position.x + 'px'
	div.style.top = item.position.y + 'px'
	div.onclick = function () {
	  //console.log(item.attrs.label.id, '=====id');
	  FormLoadHelper.openMenuItem({menuItemId:item.attrs.label.id,
		onlyQuery:false,label:item.attrs.label.text,checkHas:false,fromMainMenu:true});
	}
	div.onmouseover = function () {
	  div.style.cursor = 'pointer'
	}
	div.onmouseout = function () {
  
	}
	let content = document.getElementById(_idp);
	content.appendChild(div)
  }
  
  static resizeCanvas(_idp,_id) {
	let contentWidth = document.getElementById(_idp).clientWidth
	let contentHeight = document.getElementById(_idp).clientHeight
	let c = document.getElementById(_id);
	c.width = contentWidth
	c.height = contentHeight
  }
}



// WEBPACK FOOTER //
// ./src/utils/CommonUtil.js